import type { FunctionComponent } from 'react';
import React from 'react';

/**
 * Coins Icon
 */
export const CoinsIcon: FunctionComponent<unknown> = (props) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8 6.5C11.0376 6.5 13.5 5.38071 13.5 4C13.5 2.61929 11.0376 1.5 8 1.5C4.96243 1.5 2.5 2.61929 2.5 4C2.5 5.38071 4.96243 6.5 8 6.5Z"
        stroke="#6B7A86"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.5 6.5V7C2.5 8.381 4.962 9.5 8 9.5C11.038 9.5 13.5 8.381 13.5 7V6.5"
        stroke="#6B7A86"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.5 9.5V10C2.5 11.381 4.962 12.5 8 12.5C11.038 12.5 13.5 11.381 13.5 10V9.5"
        stroke="#6B7A86"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.5 12.5V13C2.5 14.381 4.962 15.5 8 15.5C11.038 15.5 13.5 14.381 13.5 13V12.5"
        stroke="#6B7A86"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
